import { mapToYouboraConfig } from './map-to-youbora-config';

export const mapToMiPlayerConfig = (
  config,
  playerId,
  videoId,
  resolvedLanguage,
  visitorId,
  watermark,
  userGaveConsent
) => {
  return {
    poster: config.stillSources ? Object.values(config.stillSources)[0] : undefined,
    posters: config.posters,
    sources: {
      hls: getHlsSources(config.videoSources.html.auto),
      progressive: getProgressiveSources(config.videoSources.html),
    },
    metadata: {
      videoId: videoId,
      title: config.videoMetaData.title,
      description: config.structuredData.description,
    },
    settings: getSettings(config),
    tracks: getTracks(config.videoTracks),
    storyboard: config.storyboard,
    chapters: config.chapters?.length > 0 ? { und: config.chapters } : undefined,
    lng: resolvedLanguage,
    plugins: getPlugins(config, playerId, videoId, visitorId),
    watermark: { content: watermark, position: 'top-center' },
    analyticsMode: userGaveConsent ? 'full' : 'minimal',
    downloadSources: config.downloadSources,
  };
};

function getTracks(videoTracks) {
  if (!videoTracks) return;

  return videoTracks.map((track, index) => {
    const country = track.country ? '-' + track.country.toUpperCase() : '';

    return {
      id: 'track-' + index,
      kind: track.type.toLowerCase(),
      srclang: track.language + country,
      label: track.label,
      src: track.source,
    };
  });
}

function getPlugins(config, playerId, videoId, visitorId) {
  return {
    youboraAnalytics: mapToYouboraConfig(config, playerId, videoId, visitorId),
    kollective: config.playerDefinition.kollective,
  };
}

function getSettings(config) {
  const { playerDefinition: options } = config;

  return {
    ...options,
    audioOnly: config.audioOnly,
    audioOnlyImageUrl: config.poster,
    audioOnlyImageUrls: config.posters, // responsive cover needs to be implemented in mi-player
    liveUI: false,
    hideTitle: true, // when a title is set, its also by default visible, so we hide it until its configurable
  };
}

function getHlsSources(sources) {
  if (!sources || sources.length === 0) return;

  return sources.map((source) => ({
    type: source.mimeType,
    src: source.source,
  }))[0];
}

function getProgressiveSources(sources) {
  const result = {};
  const sourcesCopy = { ...sources };

  delete sourcesCopy.auto; // remove hls source

  for (const key of Object.keys(sourcesCopy)) {
    if (!sourcesCopy[key]) {
      continue;
    }

    result[key] = sourcesCopy[key].map((source) => ({
      type: source.mimeType,
      src: source.source,
    }));
  }

  return result;
}
